// Import Fonts
import cogoToast from 'cogo-toast';
import './static/fonts/MediaSans/mediasans.css';
import './static/fonts/ParaSupreme/parasupreme.css';
import './static/fonts/Tobias/tobias.css';

window.__IS_DEV__ = process.env.NODE_ENV === 'development';
window.__IS_PROD__ = process.env.NODE_ENV === 'production';
window.__IS_OFFICE_DOMAIN__ = window.location.hostname === 'office.shopmy.us' || window.location.host === 'localhost:3002';

// Feature flags — flip to true when the feature ships
window.__IS_VIBE_SEARCH_LIVE__ = false;

window.ALERT = cogoToast;
